import { render, staticRenderFns } from "./statisticsIndex.vue?vue&type=template&id=757befac&scoped=true&"
import script from "./statisticsIndex.vue?vue&type=script&lang=js&"
export * from "./statisticsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757befac",
  null
  
)

export default component.exports